// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.launch:hover {
  cursor: pointer;
  background-color: #267833;
}

a {
  text-decoration: none;
  color: black;
}

.fieldOverView {
  background-color: white;
  color: green;
  position: absolute;
  z-index: 10;
  top: 50px;
  left: 30px;
}

.deleteButton {
  background-color: white;
  color: red;
  position: absolute;
  z-index: 10;
  top: 10px;
  right: 10px;
}

.editButton {
  background-color: white;
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/app/field/field.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb","sourcesContent":["button.launch:hover {\n  cursor: pointer;\n  background-color: #267833;\n}\n\na {\n  text-decoration: none;\n  color: black;\n}\n\n.fieldOverView {\n  background-color: white;\n  color: green;\n  position: absolute;\n  z-index: 10;\n  top: 50px;\n  left: 30px;\n}\n\n.deleteButton {\n  background-color: white;\n  color: red;\n  position: absolute;\n  z-index: 10;\n  top: 10px;\n  right: 10px;\n}\n\n.editButton {\n  background-color: white;\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
